import React from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Checkbox from '@mui/material/Checkbox';

export const ModalPerido = (props) => {
	const {
		ModalPer,
		setModalPer,
		servicio,
		changeServicioHorarioDiaEstado,
		cambiarHora,
		anadirPeriodo,
		borrarPeriodo,
	} = props;

	/*
    const generarIntervalosInicio = (intervalo, hora_init) => {
        let intervalo_millis = (parseInt(intervalo.substr(0, 2)) * 60 + parseInt(intervalo.substr(3))) * 60000; // Convertimos el intervalo a milisegundos
        let hora_inicio = new Date(`2000-01-01T${hora_init}:00`);
        let hora_fin = new Date(`2000-01-02T00:00:00`);
        hora_fin.setTime(hora_fin.getTime() - intervalo_millis); // Restamos el intervalo a la hora final
        let intervalos = [];
        let fecha_actual = hora_inicio;
        while (fecha_actual <= hora_fin) {
            let hora_actual = `${fecha_actual.getHours().toString().padStart(2, '0')}:${fecha_actual.getMinutes().toString().padStart(2, '0')}`;
            intervalos.push(hora_actual);
            fecha_actual.setTime(fecha_actual.getTime() + intervalo_millis);
        }
        return intervalos;
    }

    const sumarTiempo = (hora, intervalo) => {
        // Separar la hora y los minutos en variables separadas
        var partesHora = hora.split(":");
        var horas = parseInt(partesHora[0]);
        var minutos = parseInt(partesHora[1]);

        var partesIntervalo = intervalo.split(":");
        var horasIntervsalo = parseInt(partesIntervalo[0]);
        var minutosIntervalo = parseInt(partesIntervalo[1]);

        // Sumar un minuto a los minutos
        minutos += minutosIntervalo;

        // Si los minutos superan los 59, incrementar la hora y ajustar los minutos
        if (minutos > 59) {
            horas += 1;
            minutos = minutos % 60;
        }
        horas = horas + horasIntervsalo

        // Ajustar las horas para mantener el formato "hh"
        horas = horas % 24;
        horas = horas < 10 ? "0" + horas : horas;

        // Ajustar los minutos para mantener el formato "mm"
        minutos = minutos < 10 ? "0" + minutos : minutos;

        // Devolver la hora sumada en formato "hh:mm"
        return horas + ":" + minutos;
    }
    const generarIntervalosFin = (intervalo, hora_init) => {
        let intervalo_millis = (parseInt(intervalo.substr(0, 2)) * 60 + parseInt(intervalo.substr(3))) * 60000; // Convertimos el intervalo a milisegundos
        hora_init = sumarTiempo(hora_init, intervalo)
        let hora_inicio = new Date(`2000-01-01T${hora_init}:00`);
        let hora_fin = new Date(`2000-01-02T00:00:00`);
        hora_fin.setTime(hora_fin.getTime() - intervalo_millis); // Restamos el intervalo a la hora final
        let intervalos = [];
        let fecha_actual = hora_inicio;
        while (fecha_actual <= hora_fin) {
            let hora_actual = `${fecha_actual.getHours().toString().padStart(2, '0')}:${fecha_actual.getMinutes().toString().padStart(2, '0')}`;
            intervalos.push(hora_actual);
            fecha_actual.setTime(fecha_actual.getTime() + intervalo_millis);
        }
        return intervalos;
    }

    */
	return (
		<Modal
			centered={true}
			isOpen={ModalPer}
			className='modal-horarios'
			size='lg'
		>
			<ModalHeader>
				<div className='titulo-modal'>Horario del servicio {servicio.nombre}</div>
			</ModalHeader>
			<ModalBody>
				<div className='modal-peridos'>
					<p>
						Definie el horario en qel que ofreces este servicio. Puedes seleccionar mas
						de un periodo para un mismo dia.
					</p>
					<div className='separador' />
					{servicio.horario.map((dia) => (
						<div className='element-anadir-horario'>
							<div className='element-check-horario'>
								<div className='check-horario centrador '>
									<Checkbox
										defaultChecked
										checked={dia.estado}
										onChange={() => {
											changeServicioHorarioDiaEstado(servicio.id, dia.nombre);
										}}
										sx={{color: '23C290', '&.Mui-checked': {color: '#23C290'}}}
									/>
								</div>
								<div className='label-check-horario '>
									<b>{dia.nombre}</b>
								</div>
							</div>
							<div className='periodos-horario '>
								{dia.estado ? (
									dia.periodos.map((per) => (
										<div className='periodo'>
											<input
												type='time'
												className='servInput tipe-imput-horarios'
												value={per.hora_inicio}
												onChange={(event) =>
													cambiarHora(
														servicio.id,
														dia.nombre,
														per.id,
														true,
														event
													)
												}
											/>
											<div className='centrador'>-</div>
											<input
												type='time'
												className='servInput tipe-imput-horarios'
												value={per.hora_fin}
												onChange={(event) =>
													cambiarHora(
														servicio.id,
														dia.nombre,
														per.id,
														false,
														event
													)
												}
											/>
											{per.id !== 1 && (
												<div className='centrador'>
													<div
														className='icono-delete-periodo '
														onClick={() =>
															borrarPeriodo(
																servicio.id,
																dia.nombre,
																per.id
															)
														}
													>
														<svg
															xmlns='http://www.w3.org/2000/svg'
															width='20'
															height='20'
															fill='currentColor'
															class='bi bi-trash3'
															viewBox='0 0 16 16'
														>
															<path d='M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z' />
														</svg>
													</div>
												</div>
											)}
											
											{per.hora_inicio !== '' &&
												per.hora_fin !== '' &&
												per.solapamiento && (
													<div className='mensaje-solapamiento-periodo'>
														* Hay solapamiento en este periodo.
													</div>
												)}
											{per.hora_inicio === '' && per.hora_fin === '' ? (
												<div className='mensaje-solapamiento-periodo'>
													* La hora de inicio y finalizacion esta vacia.
												</div>
											) : per.hora_inicio === '' ? (
												<div className='mensaje-solapamiento-periodo'>
													* La hora de inicio esta vacia.
												</div>
											) : (
												per.hora_fin === '' && (
													<div className='mensaje-solapamiento-periodo'>
														* La hora de finalización esta vacia.
													</div>
												)
											)}
										</div>
									))
								) : (
									<div className='centrador no-disponible'>No disponible</div>
								)}
							</div>
							<div className='opciones-periodos '>
								<div className='icono-modal-periodos '>
									<div
										className='icono-modal-periodos-centrador'
										onClick={() => anadirPeriodo(servicio.id, dia.nombre)}
									>
										<svg
											xmlns='http://www.w3.org/2000/svg'
											width='20'
											height='20'
											fill='currentColor'
											class='bi bi-plus-square'
											viewBox='0 0 16 16'
										>
											<path d='M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z' />
											<path d='M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z' />
										</svg>
									</div>
								</div>
								{/*
                                    <div className='icono-modal-periodos '>
                                        <div className='icono-modal-periodos-centrador'><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-clipboard" viewBox="0 0 16 16"><path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z" /><path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z" /></svg></div>
                                    </div>
                                */}
							</div>
						</div>
					))}
				</div>
			</ModalBody>
			<div className='espacio-separadro-footer-modal-horario' />
			<div className='separador' />
			<ModalFooter>
				<div className='button-modal-registroEmpresa centrador'>
					<div
						className='button'
						onClick={() => {
							setModalPer(!ModalPer);
						}}
					>
						<b>Aceptar</b>
					</div>
				</div>
			</ModalFooter>
		</Modal>
	);
};
/*


<input
    type="time"
    className='tipe-imput-horarios'
    value={per.hora_inicio}
    onChange={(event) => cambiarHora(servicio.id, dia.nombre, per.id, true, event)}
/>
<div className='centrador'>-</div>
<input
    type="time"
    className='tipe-imput-horarios'
    value={per.hora_fin}
    onChange={(event) => cambiarHora(servicio.id, dia.nombre, per.id, false, event)}
/>

*/
